import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';
import { PLATFORM_HEADERS } from './platform';

const BASE = import.meta.env.VITE_125_PLATFORM_PUBLIC_BASE_URL;

const response = {
	// GET /companies/snippets/all: internal, cross-tenant, offset pagination. The store
	// builds `params` and omits unset filters, because URLSearchParams would send a
	// literal "undefined".
	async getAllSnippets(params: Record<string, string>): Promise<any> {
		return await api(
			HTTP_TYPES.GET,
			`${BASE}/companies/snippets/all`,
			undefined,
			params,
			'application/json',
			'v1',
			{ ...PLATFORM_HEADERS },
		);
	},
	// Same route with format=csv. Read as text, not a blob, so a 422 (too many rows)
	// still arrives as parsed JSON carrying `total` and `limit`.
	async exportAllSnippets(params: Record<string, string>): Promise<any> {
		return await api(
			HTTP_TYPES.GET,
			`${BASE}/companies/snippets/all`,
			undefined,
			{ ...params, format: 'csv' },
			'application/json',
			'v1',
			{ ...PLATFORM_HEADERS, Accept: 'text/csv' },
		);
	},
};

export default response;
